import { Box, InfoIcon, MarkdownFormatter, SxProps, Theme, Tooltip, Typography } from '@methanesat/ui-components';
import { useTranslate } from '../../../hooks';

interface TargetBoundaryLegendProps {
    sx?: SxProps<Theme>;
}

export const TargetBoundaryLegend = ({ sx }: TargetBoundaryLegendProps) => {
    const t = useTranslate();
    return (
        <Box display="flex" flexDirection="row" sx={[...(Array.isArray(sx) ? sx : [sx])]} alignItems={'center'}>
            <Box
                sx={(theme) => ({
                    height: '1px',
                    width: '22px',
                    backgroundColor: theme.palette.primary.main,
                    alignSelf: 'center',
                    marginRight: theme.spacing(1.5)
                })}
            />
            <Typography fontSize="0.8rem">
                <MarkdownFormatter markdown={t('emissionsMapPage.mapModals.target.targetBoundaryLegend')} />
            </Typography>
            <Tooltip
                enterTouchDelay={0}
                leaveTouchDelay={3000}
                title={t('emissionsMapPage.mapModals.target.targetBoundaryTooltip')}
            >
                <InfoIcon sx={{ fontSize: '15px', padding: '0px', marginLeft: '4px' }} />
            </Tooltip>
        </Box>
    );
};
